<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
      </div>
      <div class="filter-container">
        <el-form :inline="true" :model="resourceSupplierManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="resourceSupplierManageInfo.conditions.supplierName" placeholder="请输入供应商名称" clearable />
          </el-form-item>
          <el-form-item>
            <el-input v-model="resourceSupplierManageInfo.conditions.tel" placeholder="请输入联系方式" clearable />
          </el-form-item>
          <el-form-item>
            <el-input v-model="resourceSupplierManageInfo.conditions.rsId" placeholder="请输入供应商编号" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryResourceSupplierMethod">
              <i class="el-icon-search"></i> 查询
            </el-button>
            <el-button @click="_resetResourceSupplierMethod">
              <i class="el-icon-refresh"></i> 重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>供应商信息</span>
        <div>
          <el-button v-if="resourceSupplierManageInfo.returnFlag === '1'" type="text" @click="_goBack">
            <i class="el-icon-close"></i> 返回
          </el-button>
          <el-button type="primary" size="small" @click="_openAddResourceSupplierModal">
            <i class="el-icon-plus"></i> 添加
          </el-button>
        </div>
      </div>
      <el-table :data="resourceSupplierManageInfo.resourceSuppliers" border style="width: 100%">
        <el-table-column prop="rsId" label="供应商编号" align="center" />
        <el-table-column prop="supplierName" label="供应商名称" align="center" />
        <el-table-column prop="address" label="供应商地址" align="center" />
        <el-table-column prop="tel" label="供应商联系方式" align="center" />
        <el-table-column prop="contactName" label="联系人姓名" align="center" />
        <el-table-column prop="accountBank" label="开户行" align="center" />
        <el-table-column prop="bankAccountNumber" label="开户行账号" align="center" />
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="_openEditResourceSupplierModel(scope.row)">修改</el-button>
            <el-button size="mini" type="danger" @click="_openDeleteResourceSupplierModel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="resourceSupplierManageInfo.total"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <add-resource-supplier ref="addResourceSupplier" @refresh="_queryResourceSupplierMethod" />
    <edit-resource-supplier ref="editResourceSupplier" @refresh="_queryResourceSupplierMethod" />
    <delete-resource-supplier ref="deleteResourceSupplier" @refresh="_queryResourceSupplierMethod" />
  </div>
</template>

<script>
import { listResourceSuppliers } from '@/api/goods/resourceSupplierApi'
import AddResourceSupplier from '@/components/goods/addResourceSupplier/addResourceSupplier'
import EditResourceSupplier from '@/components/goods/editResourceSupplier/editResourceSupplier'
import DeleteResourceSupplier from '@/components/goods/deleteResourceSupplier/deleteResourceSupplier'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ResourceSupplierManage',
  components: {
    AddResourceSupplier,
    EditResourceSupplier,
    DeleteResourceSupplier
  },
  data() {
    return {
      resourceSupplierManageInfo: {
        resourceSuppliers: [],
        total: 0,
        records: 1,
        moreCondition: false,
        rsId: '',
        returnFlag: '',
        conditions: {
          supplierName: '',
          tel: '',
          rsId: '',
          page: 1,
          row: 10
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this.resourceSupplierManageInfo.returnFlag = this.$route.query.returnFlag
    this._listResourceSuppliers(this.currentPage, this.pageSize)
    console.log(this.resourceSupplierManageInfo.moreCondition)
  },
  methods: {
    _listResourceSuppliers(page, rows) {
      this.resourceSupplierManageInfo.conditions.page = page
      this.resourceSupplierManageInfo.conditions.row = rows
      this.resourceSupplierManageInfo.conditions.shopId = getShopId()

      const params = {
        ...this.resourceSupplierManageInfo.conditions,
        supplierName: this.resourceSupplierManageInfo.conditions.supplierName.trim(),
        tel: this.resourceSupplierManageInfo.conditions.tel.trim(),
        rsId: this.resourceSupplierManageInfo.conditions.rsId.trim()
      }

      listResourceSuppliers(params).then(response => {
        this.resourceSupplierManageInfo.total = response.total
        this.resourceSupplierManageInfo.records = response.records
        this.resourceSupplierManageInfo.resourceSuppliers = response.data
      }).catch(error => {
        console.error('请求失败处理', error)
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listResourceSuppliers(val, this.pageSize)
    },
    _openAddResourceSupplierModal() {
      this.$refs.addResourceSupplier.open()
    },
    _openEditResourceSupplierModel(row) {
      this.$refs.editResourceSupplier.open(row)
    },
    _openDeleteResourceSupplierModel(row) {
      this.$refs.deleteResourceSupplier.open(row)
    },
    _queryResourceSupplierMethod() {
      this.currentPage = 1
      this._listResourceSuppliers(this.currentPage, this.pageSize)
    },
    _resetResourceSupplierMethod() {
      this.resourceSupplierManageInfo.conditions.supplierName = ''
      this.resourceSupplierManageInfo.conditions.tel = ''
      this.resourceSupplierManageInfo.conditions.rsId = ''
      this.currentPage = 1
      this._listResourceSuppliers(this.currentPage, this.pageSize)
    },
    _goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.filter-container {
  padding-bottom: 10px;
}

.box-card {
  margin-bottom: 20px;
}
</style>